import { CommonModule } from '@angular/common';
import { Component, computed, input, output, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatChip, MatChipSet } from '@angular/material/chips';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'table-datatable-multi-values-content',
  templateUrl: './datatable-multi-values-content.component.html',
  styleUrls: ['./datatable-multi-values-content.component.scss'],
  imports: [MatButtonModule, MatChipSet, MatChip, MatIcon, MatTooltip, CommonModule],
})
export class DatatableMultiValuesContentComponent {
  values = input<string[]>();
  editable = input(false);
  emptySymbol = input('—');
  isCompactMode = input(false);

  cellClick = output<string[]>();

  private isExpandedLocally = signal(false);

  showMoreTooltip = computed(() => this.values()?.join(', '));

  get isExpanded() {
    return this.isExpandedLocally();
  }

  onChipClick(event: MouseEvent) {
    event.stopPropagation();
    if (this.editable()) this.cellClick.emit(this.values() ?? []);
  }

  onCellClick(event: MouseEvent) {
    if (this.editable()) {
      event.stopPropagation();
      this.cellClick.emit(this.values() ?? []);
    }
  }

  onClickShowMore(event: MouseEvent) {
    event.stopPropagation();
    this.isExpandedLocally.set(true);
  }

  onClickShowLess(event: MouseEvent) {
    event.stopPropagation();
    this.isExpandedLocally.set(false);
  }
}
